/**
 * Categorical series colours. Ordered so neighbouring slices stay
 * distinguishable, and dark enough for white text to sit on them if needed.
 */
export const SERIES_COLORS: readonly string[] = [
  // Was #4f46e5 — an indigo left behind by an earlier theme, still labelled
  // "brand-700" long after the brand had stopped being indigo.
  '#0F2E50', // brand-700 (the logo navy)
  '#0ea5e9', // sky-500
  '#10b981', // emerald-500
  '#f59e0b', // amber-500
  '#ef4444', // red-500
  '#8b5cf6', // violet-500
  '#14b8a6', // teal-500
  '#64748b', // slate-500
];

export function seriesColor(index: number): string {
  return SERIES_COLORS[index % SERIES_COLORS.length];
}
